import React from "react";
import "./card-large.css";

const CardLarge = ({ property1, className, text = "J" }) => {
  return (
    <div className={`card ${property1} ${className}`}>
      {(property1 === "clubs" ||
        property1 === "diamonds" ||
        property1 === "hearts" ||
        property1 === "spades") && (
        <div className="frame">
          <img 
            src={`/svgs/${property1}-large.svg`}
            alt={property1}
            className="suit"
          />
          <div className="text">
            {text}
          </div>
        </div>
      )}
    </div>
  );
};

export default CardLarge;